export const SET_TOKEN_DETAILS = 'SET_TOKEN_DETAILS';
export const SET_USER = 'SET_USER';
export const GET_USER_DETAILS_FROM_TOKEN = 'GET_USER_DETAILS_FROM_TOKEN';
export const SET_SELECTED_ACCESS_GROUP = 'SET_SELECTED_ACCESS_GROUP';
export const RESET_SELECTED_ACCESS_GROUP = 'RESET_SELECTED_ACCESS_GROUP';
export const SET_LOGGED_OUT = 'SET_LOGGED_OUT';
export const SET_AUTHORIZATION_FAILURE = 'SET_AUTHORIZATION_FAILURE';
export const SET_ACCESS_GROUP_LIST = 'SET_ACCESS_GROUP_LIST';
export const SET_IS_FIRSTVISIT = 'SET_IS_FIRSTVISIT';
export const SET_PERMISSION_LEVEL = 'SET_PERMISSION_LEVEL';
export const REGISTER_TEAM = 'REGISTER_TEAM';
